import React from 'react';

import { Button, ButtonProps } from '@rover/kibble/core';
import { useApiTrainerApplicationResetUpdate } from '@rover/rsdk/src/apiClient/latest/api-trainer-application-reset-update';
import { ProviderStateEnum } from '@rover/rsdk/src/apiClient/latest/model/providerStateEnum';
import { ServiceTypeSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/serviceTypeSlugEnum';
import {
  FLAGS,
  useFrontendConfiguration,
} from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';
import type { Service } from '@rover/types/src/Service';
import { redirect } from '@rover/utilities/url';

const PROFILE_URL = '/provider-profile/';
const SERVICE_SELECT_URL = '/account/continue/?next=/account/profile/start/';

export type Props = {
  providerState: string;
  services?: Service[];
  onClickExtra?: () => void;
} & ButtonProps;

export const TrainerApplicationResetButton: React.FC<Props> = ({
  providerState,
  services,
  children,
  variant = 'secondary',
  fullWidth = true,
  onClickExtra,
  ...buttonProps
}) => {
  const { mutateAsync } = useApiTrainerApplicationResetUpdate();
  const { isFlagActive } = useFrontendConfiguration();
  const rolloutChangeSignUpService = isFlagActive(FLAGS.ROLLOUT_CHANGE_SIGN_UP_SERVICE);

  const handleReset = async (): Promise<void> => {
    try {
      await mutateAsync();
      if (onClickExtra) {
        onClickExtra();
      }
      redirect(SERVICE_SELECT_URL);
    } catch (error) {
      if (onClickExtra) {
        onClickExtra();
      }
      redirect(PROFILE_URL);
    }
  };
  const handleReturn = (): void => {
    if (onClickExtra) {
      onClickExtra();
    }
    redirect(PROFILE_URL);
  };

  if (
    providerState === ProviderStateEnum.provider ||
    providerState === ProviderStateEnum.training_only_provider
  ) {
    return (
      <Button fullWidth={fullWidth} variant={variant} onClick={handleReturn} {...buttonProps}>
        {children ||
          /* TODO (DEV-104195): Translate below text after training pilot launch */
          'Return to your profile'}
      </Button>
    );
  }

  const nonTrainingService: Service = services?.find(
    (service) => service.slug !== ServiceTypeSlugEnum['dog-training']
  );

  return (
    <Button fullWidth={fullWidth} variant={variant} onClick={handleReset} {...buttonProps}>
      {children ||
        /* TODO (DEV-104195): Translate below text after training pilot launch */
        (nonTrainingService && !rolloutChangeSignUpService
          ? `Continue to ${nonTrainingService.name}`
          : 'Select another service')}
    </Button>
  );
};
